module.exports = __webpack_public_path__ + "img/shop.04a64e08.svg";